export const getFileUploadStatusFromDocumentForm = (state, formId) => {
    return !!(state.form[formId] && state.form[formId].values);
}